import { createApi } from "@reduxjs/toolkit/query/react";
import { apiBaseQuery } from "../utils/apiBaseQuery";
import { NotificationInterface } from "../interfaces/NotificationInterface";
import { MetaInterface } from "../interfaces/MetaInterface";
import { ApiEnum } from "../enums/ApiEnum";
import { createQueryString } from "../utils/createQueryString";

export const notificationApiSlice = createApi({
    reducerPath: "notificationApiSlice",
    baseQuery: apiBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        getNotifications: builder.query<
            {
                data: NotificationInterface[];
                meta?: MetaInterface;
            },
            {
                page?: number;
                items_per_page?: number;
                filter?: {
                    employee_id?: number;
                    establishment_id?: number;
                };
            }
        >({
            query: (values) => {
                return {
                    url: `${ApiEnum.NOTIFICATION}?${createQueryString(values)}`,
                    method: "GET",
                };
            },
        }),
    }),
});

export default notificationApiSlice.reducer;

export const { useGetNotificationsQuery } = notificationApiSlice;
